<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <b-card>
          <div slot="header">
            <strong>{{$t('NEWRULE')}}</strong>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NAME')">
                <inputvalidation :formerror="formError" name="name"><b-form-input type="text" v-model="formData.name" v-bind:placeholder="$t('NAME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('MODULE')">
                <inputvalidation :formerror="formError" name="moduleId">
                  <select class="form-control" name="moduleId" v-model="formData.moduleId">
                    <option value="">{{$t('SELECTMODULE')}}</option>
                    <option v-for="item in modulesData.root" :value="item.moduleId">{{item.moduleName}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('RULETYPE')">
                <inputvalidation :formerror="formError" name="ruleType">
                  <select class="form-control" name="ruleType" v-model="formData.ruleType">
                    <option value="">{{$t('SELECTRULETYPE')}}</option>
                    <option value="time">{{$t('TIME')}}</option>
                    <option value="conditions">{{$t('RC_RULETYPE')}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('BUTTONORRELAY')">
                <inputvalidation :formerror="formError" name="buttonOrRelay">
                  <select class="form-control" name="buttonOrRelay" v-model="formData.buttonOrRelay">
                    <option value="button">{{$t('BUTTON')}}</option>
                    <option value="relay">{{$t('RELAY')}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row" v-if="hasTime(formData.ruleType)">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('STARTTIME')">
                <inputvalidation :formerror="formError" name="startTime"><b-form-input type="text" v-model="formData.startTime" v-bind:placeholder="$t('STARTTIME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row" v-if="hasTime(formData.ruleType)">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('ENDTIME')">
                <inputvalidation :formerror="formError" name="endTime"><b-form-input type="text" v-model="formData.endTime" v-bind:placeholder="$t('ENDTIME')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('COMMANDTYPE')">
                <inputvalidation :formerror="formError" name="commandType">
                  <select class="form-control" name="commandType" v-model="formData.commandType">
                    <option value="">{{$t('SELECTCOMMANDTYPE')}}</option>
                    <option value="1">{{$t('ON')}}</option>
                    <option value="0">{{$t('OFF')}}</option>
                    <option value="3">{{$t('SECONDRELAYON')}}</option>
                    <option value="2">{{$t('SECONDRELAYOFF')}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('ACTIONTYPE')">
                <inputvalidation :formerror="formError" name="actionType">
                  <select class="form-control" name="actionType" v-model="formData.actionType">
                    <option value="relay">{{$t('ACTIONRELAY')}}</option>
                    <option value="notify">{{$t('ACTIONNOTIFY')}}</option>
                    <option value="both">{{$t('ACTIONBOTH')}}</option>
                  </select>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row" v-if="notifies(formData.actionType)">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NOTIFYTEXT')">
                <inputvalidation :formerror="formError" name="notifyText"><b-form-input type="text" v-model="formData.notifyText" v-bind:placeholder="$t('NOTIFYTEXTHINT')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('DAYS')">
                <inputvalidation :formerror="formError" name="days">
                  <multiselect name="days" v-model="formData.days" :multiple="true" :options="days" track-by="key" label="value" :placeholder="$t('SELECTDAYS')" :searchable="false" :allow-empty="true">
                    <template slot="singleLabel" slot-scope="{ option }">{{ option.value }}</template>
                  </multiselect>
                </inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('REVERTAFTERSEC')">
                <inputvalidation :formerror="formError" name="revertAfterSec"><b-form-input type="text" v-model="formData.revertAfterSec" v-bind:placeholder="$t('REVERTAFTERSEC')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('NOTRIGGERAFTERSEC')">
                <inputvalidation :formerror="formError" name="noTriggerAfterSec"><b-form-input type="text" v-model="formData.noTriggerAfterSec" v-bind:placeholder="$t('NOTRIGGERAFTERSEC')"></b-form-input></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <b-form-fieldset v-bind:label="$t('IGNOREMANUALOVERRIDE')">
                <inputvalidation :formerror="formError" name="ignoreManualOverride"><b-form-checkbox v-model="formData.ignoreManualOverride" value="1" unchecked-value="0"></b-form-checkbox></inputvalidation>
              </b-form-fieldset>
            </div>
          </div>
          <div slot="footer">
            <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
            <b-button type="submit" size="sm" variant="primary" v-on:click.prevent="save(formData)"><i class="fa fa-dot-circle-o"></i> {{$t('SUBMIT')}}</b-button>
          </div>
        </b-card>
      </div><!--/.col-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('RULES')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('MODULE')}}</th>
                    <th>{{$t('RULETYPE')}}</th>
                    <th>{{$t('BUTTONORRELAY')}}</th>
                    <th>{{$t('STARTTIME')}}</th>
                    <th>{{$t('ENDTIME')}}</th>
                    <th>{{$t('COMMANDTYPE')}}</th>
                    <th>{{$t('ACTIONTYPE')}}</th>
                    <th>{{$t('NOTIFYTEXT')}}</th>
                    <th>{{$t('DAYS')}}</th>
                    <th>{{$t('REVERTAFTERSEC')}}</th>
                    <th>{{$t('NOTRIGGERAFTERSEC')}}</th>
                    <th>{{$t('IGNOREMANUALOVERRIDE')}}</th>
                    <th>{{$t('RC_CONDITIONS')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in data.root">
                    <td><b-form-input type="text" v-model="item.name" v-bind:placeholder="$t('NAME')"></b-form-input></td>
                    <td>
                      <select class="form-control" name="moduleId" v-model="item.moduleId">
                        <option v-for="itemsec in modulesData.root" :value="itemsec.moduleId">{{itemsec.moduleName}}</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-control" name="ruleType" v-model="item.ruleType">
                        <option value="time">{{$t('TIME')}}</option>
                        <option value="conditions">{{$t('RC_RULETYPE')}}</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-control" name="buttonOrRelay" v-model="item.buttonOrRelay">
                        <option value="button">{{$t('BUTTON')}}</option>
                        <option value="relay">{{$t('RELAY')}}</option>
                      </select>
                    </td>
                    <td>
                      <b-form-input v-if="hasTime(item.ruleType)" type="text" v-model="item.startTime" v-bind:placeholder="$t('STARTTIME')"></b-form-input>
                    </td>
                    <td>
                      <b-form-input v-if="hasTime(item.ruleType)" type="text" v-model="item.endTime" v-bind:placeholder="$t('ENDTIME')"></b-form-input>
                    </td>
                    <td>
                      <select class="form-control" name="commandType" v-model="item.commandType">
                        <option value="">{{$t('SELECTCOMMANDTYPE')}}</option>
                        <option value="1">{{$t('ON')}}</option>
                        <option value="0">{{$t('OFF')}}</option>
                        <option value="3">{{$t('SECONDRELAYON')}}</option>
                        <option value="2">{{$t('SECONDRELAYOFF')}}</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-control" name="actionType" v-model="item.actionType">
                        <option value="relay">{{$t('ACTIONRELAY')}}</option>
                        <option value="notify">{{$t('ACTIONNOTIFY')}}</option>
                        <option value="both">{{$t('ACTIONBOTH')}}</option>
                      </select>
                    </td>
                    <td>
                      <b-form-input v-if="notifies(item.actionType)" type="text" v-model="item.notifyText" v-bind:placeholder="$t('NOTIFYTEXTHINT')"></b-form-input>
                    </td>
                    <td>
                      <multiselect name="days" v-model="item.days" :multiple="true" :options="days" track-by="key" label="value" :placeholder="$t('SELECTDAYS')" :searchable="false" :allow-empty="true">
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.value }}</template>
                      </multiselect>
                    </td>
                    <td>
                      <b-form-input type="text" v-model="item.revertAfterSec" v-bind:placeholder="$t('REVERTAFTERSEC')"></b-form-input>
                    </td>
                    <td>
                      <b-form-input type="text" v-model="item.noTriggerAfterSec" v-bind:placeholder="$t('NOTRIGGERAFTERSEC')"></b-form-input>
                    </td>
                    <td>
                      <b-form-checkbox v-model="item.ignoreManualOverride" value="1" unchecked-value="0"></b-form-checkbox>
                    </td>
                    <td>
                      <b-button v-if="item.ruleType == 'conditions'" size="sm" variant="outline-primary" v-on:click.prevent="editConditions(item)">
                        <i class="mdi mdi-filter-variant"></i> {{item.conditionCount || 0}}
                      </b-button>
                    </td>
                    <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="save(item)"><icon name="save"></icon> {{$t('SAVE')}}</b-button></td>
                    <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.ruleId)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                  </tr>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>

    <b-modal ref="conditionsModal" size="xl" :title="conditionsTitle" hide-footer>
      <rule-conditions
        v-if="conditionsRule"
        :key="conditionsRule.ruleId"
        :rule-id="conditionsRule.ruleId"
        :condition-operator="conditionsRule.conditionOperator"
        :sources="conditionSources"
        v-on:saved="conditionsSaved"/>
    </b-modal>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Api from '@/api/Rules';
import ModulesApi from '@/api/Modules';
import RuleConditions from '@/components/lib/RuleConditions.vue';

export default {
    name: 'Rules',
    components:
  {
      'rule-conditions': RuleConditions,
  },
    data()
    {
        const me = this;

        return {
            data: {},
            formError: {},
            modulesData: {},
            conditionSources: [],
            conditionsRule: null,
            days:
      [
          { key: '', value: me.$i18n.t('ALLDAYS') },
          { key: '1', value: me.$i18n.t('MONDAY') },
          { key: '2', value: me.$i18n.t('TUESDAY') },
          { key: '3', value: me.$i18n.t('WEDNESDAY') },
          { key: '4', value: me.$i18n.t('THURSDAY') },
          { key: '5', value: me.$i18n.t('FRIDAY') },
          { key: '6', value: me.$i18n.t('SATURDAY') },
          { key: '0', value: me.$i18n.t('SUNDAY') },
      ],
            formData:
      {
          name: '',
          moduleId: '',
          ruleType: '',
          startTime: null,
          endTime: null,
          commandType: '',
          actionType: 'relay',
          notifyText: '',
          ignoreManualOverride: '0',
          days: null,
      },
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 200,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;

        me.ruleCategoryId = me.$route.params.ruleCategoryId;
        me.getData();
        me.getModulesData();
        me.getConditionSources();
    },
    methods:
  {
      /**
       * Whether a rule type takes a time window.
       *
       * A conditions rule does not need one, but it may have one: leave both
       * empty and only the conditions decide, fill them in and the window has to
       * hold as well. That is what the engine does, see the timed check in
       * device_rules.js.
       */
      // whether this rule says anything, and so whether the text is worth asking for
      notifies(actionType)
      {
          return ['notify', 'both'].indexOf(actionType) !== -1;
      },
      hasTime(ruleType)
      {
          return ['time', 'temperatureandtime', 'buttonStatusandtime', 'conditions'].indexOf(ruleType) !== -1;
      },
      // which modules a condition can read, and what each of them measures
      async getConditionSources()
      {
          const me = this;

          try
          {
              const data = await Api.getConditionSources({});

              if (data && !data.error)
              {
                  me.conditionSources = data.data || [];
              }
          }
          catch (error)
          {
              me.$notify.notice({ error: true, notice: 'Error' });
          }
      },
      editConditions(item)
      {
          const me = this;

          me.conditionsRule = item;
          me.$refs.conditionsModal.show();
      },
      conditionsSaved(result)
      {
          const me = this;

          // keep the count on the row honest without refetching the whole list
          if (me.conditionsRule != null)
          {
              me.$set(me.conditionsRule, 'conditionCount', result.count);
              me.$set(me.conditionsRule, 'conditionOperator', result.conditionOperator);
          }

          me.$refs.conditionsModal.hide();
      },
      getModulesData()
      {
          const me = this;
          ModulesApi.selectRow(me.getParams, (data) =>
          {
              if (data.error && data.error == true)
              {
                  me.$notify.notice(data);
                  return;
              }
              me.modulesData = data;
          });
      },
      async save(item)
      {
          const me = this;

          if (typeof item.ruleId !== 'undefined')
          {
              item.id = item.ruleId;
              delete (item.ruleId);
          }

          item.days = JSON.stringify(item.days);

          item.ruleCategoryId = me.ruleCategoryId;

          const val = await Api.save(item);

          if (val.error)
          {
              me.$notify.notice(val);
              me.formError = val;
          }
          else
          {
              me.$notify.notice(val);
              me.formError = {};
              me.getData();
          }
      },
      async getData()
      {
          const me = this;
          const data = await Api.selectRow(me.getParams);

          if (data.error && data.error === true)
          {
              me.$notify.notice(data);
              return;
          }

          for (const dat of data.root)
          {
              if (dat.days != null)
              {
                  dat.days = JSON.parse(dat.days);
              }
              else
              {
                  dat.days = [];
              }
          }

          me.data = data;
      },
      deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });

                      if (data.error && data.error === true)
                      {
                          me.$notify.error(data.notice);
                      }
                      else
                      {
                          me.$notify.success(data.notice);
                      }
                      me.getData();
                  },
              });
      },
  },
    watch:
    {
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;

            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }

            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
    computed:
    {
        conditionsTitle()
        {
            const me = this;

            if (me.conditionsRule == null)
            {
                return me.$t('RC_CONDITIONS');
            }

            return `${me.$t('RC_CONDITIONS')} - ${me.conditionsRule.name}`;
        },
        getParams()
        {
            const me = this;
            const data = { ...me.pagination };
            data.ruleCategoryId = me.ruleCategoryId;
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
    },
};
</script>
